import {
    knowledgeBuilderService
} from 'shared/api';
// Using Knowledge Builder proxy service for centralized API calls
/**
 * Service class for performing Knowledge Builder Operations
 */
class KnowledgeBuilderService {

    /**
     * Cancels L1 Processing via proxy.
     * @param {Object} body - The body of the request contain collection_id and task_id.
     * @returns {Promise<Object>}
     */
    async cancelL1Processing(body) {
        const res = await knowledgeBuilderService.performRequestWithFullResponse('/v2/kb/api/v1/L1/cancel', {
            method: 'POST',
            data: body
        });
        return res;
    }

    /**
     * Fetches the processing history for a specific collection via proxy.
     * @param {string} organizationId - organization ID of the collection to fetch history for.
     * @param {string} collectionId - The ID of the collection to fetch history for.
     * @returns {Promise<Object>} The response containing the processing history.
     */
    async getCollectionProcessHistory(organizationId, collectionId) {
        const response = await knowledgeBuilderService.performRequestWithFullResponse(`/v2/kb/api/v1/history/processing-history?organization_id=${organizationId}&collection_id=${collectionId}`, {
            method: 'GET'
        });
        // const response = await knowledgeBuilderHttpClientWithCreds.get(`/history/processing-history?organization_id=${organizationId}&collection_id=${collectionId}`);
        return response;
    }

    /**
     * Export search results as CSV file via proxy.
     * @param {Object} body - The export request body containing filters and level type
     * @returns {Promise<Blob>} The CSV file as a blob for download
     */
    async exportSearchResults(body) {
        const response = await knowledgeBuilderService.performRequestWithFullResponse('/v2/kb/api/v1/search/export', {
            method: 'POST',
            data: body,
            headers: {
                Accept: 'text/csv,application/csv'
            }
        });
        return response;
    }

    /**
     * Start a web crawling job for the given domain via proxy.
     * @param {Object} body - The body of the request containing all crawl parameters.
     * @returns {Promise<Object>} The response from the server.
     */
    async startWebCrawl(body) {
        const response = await knowledgeBuilderService.performRequestWithFullResponse('/v2/kb/api/v1/data-ingestion/web/crawl', {
            method: 'POST',
            data: body
        });
        return response;
    }

    /**
     * Get list of supported file extensions for web crawling via proxy.
     * @returns {Promise<Object>} The response from the server.
     */
    async getSupportedFileExtensions() {
        const response = await knowledgeBuilderService.performRequestWithFullResponse('/v2/kb/api/v1/data-ingestion/web/supported_extensions', {
            method: 'GET'
        });
        return response;
    }
}

const kbService = new KnowledgeBuilderService();
export { kbService };
